export default {
  ruleSet: {
    ruleSet: "Rule Set",
    ruleSetCode: "Rule Set Code",
    ruleSetName: "Rule Set Name",
    ruleSetType: "Rule Type",
    collectionTarget: "Collection Target",
    usageCheck: "Usage Check",
    active: "Active",
    riskLevel: "Risk Level",
    rulesetExist: "Ruleset is already existed"
  }
};
